const SWITCH_WIDTH_PX = 40;
const HANDLE_DIAMETER_PX = 22;
const SWITCH_OFFSET_PX = 0;
const Switch = ({
    containerCheckedColor = "#fff",
    containerUncheckedColor = "#5098ef",
    handleCheckedColor = "#95a3b3",
    handleUncheckedColor = "#fff",
    value,
    onClick,
    label
}) => {



    return (<>
        <div
            style={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                cursor: 'pointer',
                width: '100%',
                justifyContent: 'space-between',
                color: '#80808e',
                fontSize: 14
            }}
            onClick={() => {
                onClick(!value)
            }}>
            {label}
            <div
                style={{
                    width: SWITCH_WIDTH_PX,
                    height: HANDLE_DIAMETER_PX + 2 * SWITCH_OFFSET_PX,
                    borderRadius: HANDLE_DIAMETER_PX,
                    border: value ? "1px #5098ef solid" : "1px #d1d3d9 solid",
                    position: "relative",
                    transition: ".3s",
                    cursor: "pointer",
                    background: value ? containerUncheckedColor : containerCheckedColor,
                }}
                onClick={() => {
                    onClick(!value);
                }}
            >
                <div
                    style={{
                        background: value ? handleUncheckedColor : handleCheckedColor,
                        borderRadius: "100%",
                        boxShadow: '0 2px 7px #0000002e',
                        height: HANDLE_DIAMETER_PX - 2,
                        width: HANDLE_DIAMETER_PX - 2,
                        position: "absolute",
                        top: SWITCH_OFFSET_PX,
                        left: value
                            ? SWITCH_WIDTH_PX - HANDLE_DIAMETER_PX - SWITCH_OFFSET_PX
                            : SWITCH_OFFSET_PX,
                        transition: ".3s",
                    }}
                ></div>
                <input
                    type="checkbox"
                    value={value}
                    onChange={(e) => {
                        onClick(e.target.value);
                    }}
                    style={{ display: "none" }}
                />
            </div>
        </div >
    </>);


};
export default Switch;